module.exports = __webpack_public_path__ + "img/markdown.d4d9ac78.svg";